import { atom } from 'jotai';
import { z } from 'zod';

import { ZInboundFormMessage } from '$models/state/message';

export type InboundFormMessageAtom = z.infer<typeof ZInboundFormMessage>;

export const formMessageAtom = atom<InboundFormMessageAtom | undefined>(undefined);
